<template>
  <div>
    <div class="normalHeader" >
      <img src="@/assets/img_lxwm.png" class="bg" />
    </div>
    <div class="panel">
      <div class="w1200">
        <div class="breader">
          <router-link to="/" class="breaderLink">首页</router-link>
          <span> / </span>
          <span class="breaderNow">联系我们</span>
        </div>
        <div class="flex">
          <div class="flexItem">
            <b>平台服务</b>
            <img src="@/assets/lx_icon1.png" class="icon" />
            <span class="blue">{{tel}}</span>
          </div>
          <div class="flexItem">
            <b>商务合作</b>
            <img src="@/assets/lx_icon2.png" class="icon" />
            <span class="blue">{{shangwu}}</span>
          </div>
          <div class="flexItem">
            <b>邮箱</b>
            <img src="@/assets/lx_icon3.png" class="icon" />
            <span class="blue">{{mail}}</span>
          </div>
        </div>
        <img src="@/assets/lx_dt.jpg" class="map" />
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'lxwm',
  components: {
  },
  data() {
    return {
      routerFrom: {},
      routerTo: {},
      tel: '0531-88773778',
      shangwu: '0531-88773778',
      mail: 'shengchuang_edu@163.com'
    }
  },
  watch: {
    $route(to, from) {
      this.routerFrom = from
      this.routerTo = to
      console.log(this.routerTo)
    }
  },
  mounted() {
  },
  methods: {

  }
}
</script>

<style scoped>
.normalHeader{width: 100%;height: 260px;}
.normalHeader .bg{display: block;width: 100%;height: 100%;object-fit: cover;}
.panel{width: 100%;height: auto;position: relative;background-color: #F8F9FD;padding-bottom: 100px;}
.w1200{width: 1200px;margin: 0 auto;}
.breader{padding-top: 30px;padding-bottom: 98px;}
.breader span{display: inline-block;color: #8C8C8C;font-size: 14px;line-height: 20px;margin-left: 8px;margin-right: 8px;}
.breader .breaderLink{display: inline-block;color: #8C8C8C;font-size: 14px;line-height: 20px;margin: 0;}
.breader .breaderLink:hover{color: #0E4AFA}
.breader .breaderNow{display: inline-block;color: #151515;font-size: 14px;line-height: 20px;margin: 0;}

.flex{width: 100%;display: flex;flex-direction: row;margin-bottom: 100px;}
.flex .flexItem{flex:1;display: flex;flex-direction: column;align-items: flex-start;}
.flex .flexItem b{color: #222;font-size: 20px;font-weight: bold;line-height: 50px;margin-bottom: 20px;display: inline-block;}
.flex .flexItem .icon{width: 32px;height: 32px;margin-bottom: 20px;display: inline-block;}
.flex .flexItem .blue{color: #0E4AFA;font-size: 36px;line-height: 50px;font-weight: bold;display: inline-block;}
.map{display: block;width: 100%;}
</style>
